<template>
    <overlay-scrollbars class="about scrollable">
        <div class="about__container">
        
            <div class="about__text">
                <p class="about__p">
                    <span>Basteleur is an</span>
                    <span>open-source font created</span>
                    <span>by Keussel</span>
                    <span>✷ ✹ ✷ ✶ ✷ ✹ ✷ ✶ ✷ ✹ ✷</span>
                    <span>
                        <a href="http://www.keussel.studio" target="_blank">www.keussel.studio</a>
                    </span>
                    <span>✷ ✹ ✷ ✶ ✷ ✹ ✷ ✶ ✷ ✹ ✷</span>
                </p>

                <p class="about__p">
                    <span>Distributed by</span>
                    <span>Velvetyne Type Foundry</span>
                    <span>✷ ✹ ✷ ✶ ✷ ✹ ✷ ✶ ✷ ✹ ✷</span>
                    <span>
                        <a href="http://www.velvetyne.fr" target="_blank">www.velvetyne.fr/</a>
                    </span>
                    <span>✷ ✹ ✷ ✶ ✷ ✹ ✷ ✶ ✷ ✹ ✷</span>
                </p>
                
                <p class="about__p">
                    <span>This website is developped</span>
                    <span>by Romain Ducrocq</span>
                    <span>✷ ✹ ✷ ✶ ✷ ✹ ✷ ✶ ✷ ✹ ✷</span>
                        <span>
                            <a href="http://www.coucou.ninja" target="_blank">www.coucou.ninja</a>
                        </span>
                    <span>✷ ✹ ✷ ✶ ✷ ✹ ✷ ✶ ✷ ✹ ✷</span>
                </p>
            </div>
            
            <info-btn to="/">
                <span>&lt;</span>
            </info-btn>

        </div>
    </overlay-scrollbars>
</template>

<script>
    import 'overlayscrollbars/css/OverlayScrollbars.css';
    import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue';
    import InfoBtn from '@/components/InfoBtn';

    export default {
        components: {
            InfoBtn,
            'overlay-scrollbars': OverlayScrollbarsComponent
        },
        deactivated () {
            $store.lastPage = this.$route.name  
        }
    }
</script>